module.exports = __webpack_public_path__ + "static/media/spoonerism-task (6).a4923fb1.mp3";